import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { COUNTRY_CHOICES } from '@/constants';
import { PublicSiteHeader } from '@/components/public/PublicSiteHeader';

const SurveyLandingPage: React.FC = () => {
  const { t, i18n } = useTranslation('survey');
  const appLang = i18n.language === 'fr' ? 'fr' : 'en';

  return (
    <div className="min-h-screen bg-[#F8FAFC] text-[#0F172A]">
      <PublicSiteHeader />
      <main className="mx-auto w-full max-w-5xl px-6 py-12">
        <section className="rounded-2xl border border-[#E2E8F0] bg-white p-8 shadow-sm md:p-12">
          <div className="mb-1 text-[10px] font-bold uppercase tracking-[0.3em] text-[#E10613]">{t('bankingSurvey')}</div>
          <h1 className="mt-3 text-3xl font-black text-[#0F172A] md:text-5xl">
            {t('chooseCountryToBegin')}
          </h1>
          <p className="mt-4 max-w-3xl text-sm text-[#475569] md:text-base">
            {t('selectCountrySub')}
          </p>

          <div className="mt-8 grid gap-4 md:grid-cols-3">
            <article className="rounded-xl border border-[#E2E8F0] bg-[#F8FAFC] p-4">
              <p className="text-[10px] font-semibold uppercase tracking-widest text-[#64748B]">{t('duration')}</p>
              <p className="mt-2 text-lg font-bold text-[#0F172A]">{t('durationValue')}</p>
            </article>
            <article className="rounded-xl border border-[#E2E8F0] bg-[#F8FAFC] p-4">
              <p className="text-[10px] font-semibold uppercase tracking-widest text-[#64748B]">{t('responses')}</p>
              <p className="mt-2 text-lg font-bold text-[#0F172A]">{t('responsesValue')}</p>
            </article>
            <article className="rounded-xl border border-[#E2E8F0] bg-[#F8FAFC] p-4">
              <p className="text-[10px] font-semibold uppercase tracking-widest text-[#64748B]">{t('whyItMatters')}</p>
              <p className="mt-2 text-lg font-bold text-[#0F172A]">{t('whyItMattersValue')}</p>
            </article>
          </div>

          <div className="mt-10 grid gap-4 md:grid-cols-3">
            {COUNTRY_CHOICES.map((choice) => {
              const countryLabel = choice.label[appLang] ?? choice.label.en;
              return (
                <Link
                  key={choice.value}
                  to={`/survey/start/${choice.value}`}
                  className="rounded-xl border border-[#E2E8F0] bg-[#F8FAFC] p-5 transition-colors hover:border-[#E10613] hover:bg-[#FEF2F2]"
                >
                  <p className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#E10613]">{t('countrySurvey')}</p>
                  <h2 className="mt-3 text-2xl font-black text-[#0F172A]">{countryLabel}</h2>
                  <p className="mt-2 text-sm text-[#475569]">
                    {t('openCountryIntro', { country: countryLabel })}
                  </p>
                  <div className="mt-5 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-[#E10613]">
                    {t('continue')} <ChevronRight size={14} />
                  </div>
                </Link>
              );
            })}
          </div>

          <div className="mt-8 flex flex-wrap gap-3">
            <Link
              to="/"
              className="rounded-lg border border-[#E2E8F0] bg-white px-5 py-3 text-xs font-bold uppercase tracking-widest text-[#475569] hover:border-[#CBD5E1] hover:text-[#0F172A]"
            >
              {t('backToBrandEdge')}
            </Link>
          </div>
        </section>
      </main>
    </div>
  );
};

export default SurveyLandingPage;
